import { useEffect, useState } from 'react';

export const useIsClientSide = () => {
  const [isOnClientSide, setIsOnClientSide] = useState(false);

  useEffect(() => setIsOnClientSide(true), []);

  return isOnClientSide;
};
